import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionClassForm from '../../../components/forms/CompetitionClassForm';
import { useCompetitionClassApi } from '../../../hooks/useCompetitionClassApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionClassDTO } from '../../../services/apiClient';

const CompetitionClassCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionClassApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Classes', href: '/admin/competitionclasses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionClassDTO) => {
    try {
      await create(data);
      navigate('/admin/competitionclasses');
    } catch (error) {
      console.error('Error creating CompetitionClass:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionclasses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CompetitionClass.Edit'
    >
        <CompetitionClassForm
          initialValues={{} as CompetitionClassDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionclasses')}
        />
    </AdminLayout>
  );
};

export default CompetitionClassCreate;